import { LocaleEnum } from '@systemeio/ui'

export const getRazorpayHelpPageLink = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.DUTCH: {
      return 'https://help-nl.systeme.io/article/1882-hoe-integreer-je-razorpay-met-systeme-io'
    }
    case LocaleEnum.DEUTSCH: {
      return 'https://help-de.systeme.io/article/1754-so-richten-sie-eine-razorpay-integration-ein'
    }
    case LocaleEnum.PORTUGUESE: {
      return 'https://help-pt.systeme.io/article/2075-como-integrar-o-razorpay-a-systeme-io'
    }
    case LocaleEnum.FRENCH: {
      return 'https://aide.systeme.io/article/1916-comment-integrer-razorpay-a-systeme-io'
    }
    case LocaleEnum.JAPANESE: {
      return 'https://help-jp.systeme.io/article/2224-how-to-integrate-razorpay-with-systeme-io'
    }
    case LocaleEnum.ARABIC: {
      return 'https://help-ar.systeme.io/article/2711-how-to-integrate-razorpay-with-systemeio'
    }
    case LocaleEnum.SPANISH: {
      return 'https://help-es.systeme.io/article/1938-como-integrar-razorpay-con-systeme-io'
    }
    case LocaleEnum.ITALIAN: {
      return 'https://help-it.systeme.io/article/1755-come-integrare-razorpay-con-systeme-io'
    }
    default: {
      return 'https://help.systeme.io/article/1752-integrate-razorpay-systeme'
    }
  }
}
